<ng-container>
  <div [class.reserved]="!!lineItem.reserved" [class.sold]="!!lineItem.sold" class="card">
    <div [class.collapsed-body]="!previewMode && collapsed" (click)="collapsed = !collapsed" class="card-header">
      <div class="align-items-center d-flex flex-column flex-md-row gap-3 text-center text-md-start">
        <div *ngIf="listing.listingType !== MarketplaceListingType.WANTED" class="image">
          <img
            *ngIf="lineItem.images?.length > 0"
            [src]="getFirstImageUrl()"
            class="type-image"
            alt="{{ equipmentItemType(equipmentItem) }}"
          />
          <img
            *ngIf="lineItem.images?.length === 0 && lineItem.itemKlass"
            class="type-image"
            alt="{{ equipmentItemService.humanizeType(lineItem.itemKlass) }}"
            src="/assets/images/{{ lineItem.itemKlass.toLowerCase() }}-placeholder.png?v=2"
          />
        </div>

        <div class="flex-grow-1">
          <div class="display-name">
            <span *ngIf="listing.listingType === MarketplaceListingType.WANTED" class="wanted">
              [{{ "Wanted" | translate }}]
            </span>

            <ng-container *ngIf="!!equipmentItem">
              <astrobin-equipment-item-display-name
                [enableBrandLink]="false"
                [enableNameLink]="false"
                [item]="equipmentItem"
                [showFrozenAsAmbiguous]="false"
                [showItemUnapprovedInfo]="false"
              ></astrobin-equipment-item-display-name>

              <a
                [routerLink]="['/equipment/explorer/', equipmentItem.klass.toLowerCase(), equipmentItem.id]"
                class="line-item-item-link"
                astrobinEventPreventDefault
                astrobinEventStopPropagation
              >
                <fa-icon icon="info-circle"></fa-icon>
              </a>
            </ng-container>
            <ng-container *ngIf="!equipmentItem">
              {{ lineItem.itemPlainText || "" }}
            </ng-container>
          </div>

          <div *ngIf="!lineItem.sold" class="offers-count">
            <span *ngIf="pendingOffers?.length === 1" [translate]="'One offer'"></span>
            <span
              *ngIf="pendingOffers?.length > 1"
              [translate]="'{{0}} offers'"
              [translateParams]="{
                '0': pendingOffers.length
              }"
            ></span>
          </div>

          <astrobin-marketplace-listing-line-item-condition
            *ngIf="listing.listingType === MarketplaceListingType.FOR_SALE"
            [lineItem]="lineItem"
          ></astrobin-marketplace-listing-line-item-condition>

          <div
            *ngIf="!previewMode && !!equipmentItem && listing.listingType === MarketplaceListingType.FOR_SALE"
            class="first-added"
          >
            {{ "First added to an image by the seller" | translate }}:
            <span class="first-added-date">
              <ng-container *ngIf="lineItem.firstAddedToAnImage; else noFirstAddedDateTemplate">
                {{
                  lineItem.firstAddedToAnImage | localDate | date: "mediumDate" : null : translateService.currentLang
                }}
              </ng-container>
              <ng-template #noFirstAddedDateTemplate>
                {{ "Unknown" | translate }}
              </ng-template>
            </span>
            <fa-icon
              [ngbTooltip]="
                'AstroBin records the dates when users associate equipment items to images. This information can be used to corroborate the legitimacy of the information provided by the seller.'
                  | translate
              "
              icon="question-circle"
            ></fa-icon>
          </div>

          <div
            *ngIf="!previewMode && !!equipmentItem && listing.listingType === MarketplaceListingType.FOR_SALE"
            class="image-counts"
          >
            <span [innerHTML]="sellerImageCount"></span>
            &middot;
            <span [innerHTML]="totalImageCount"></span>
          </div>
        </div>

        <astrobin-marketplace-listing-line-item-price
          *ngIf="listing.listingType === MarketplaceListingType.FOR_SALE"
          [lineItem]="lineItem"
          [listing]="listing"
        ></astrobin-marketplace-listing-line-item-price>

        <fa-icon *ngIf="!previewMode" [icon]="collapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
      </div>
    </div>

    <div *ngIf="previewMode || !collapsed" class="card-body">
      <div class="w-100 images">
        <astrobin-marketplace-listing-line-item-images
          [images]="lineItem.images"
        ></astrobin-marketplace-listing-line-item-images>
      </div>

      <div
        *ngIf="!!lineItem.description; else noDescriptionTemplate"
        [innerHTML]="lineItem.description | nl2br"
        class="description mt-4 w-100"
      ></div>

      <astrobin-image-search-card
        #sellerImageSearch
        *ngIf="
          !!equipmentItem && lineItem.sellerImageCount > 0 && listing.listingType === MarketplaceListingType.FOR_SALE
        "
        [header]="'Images by the seller' | translate"
        [loadMoreOnScroll]="false"
        [model]="{
          itemId: lineItem.itemObjectId,
          itemType: lineItem.itemKlass,
          username: lineItem.username,
          pageSize: 21
        }"
        [showMarketplaceItems]="false"
        [showRetailers]="false"
        [showSortButton]="false"
        [showStaticOverlay]="false"
        [showUsageButton]="false"
        class="d-block mt-5"
        ordering="-likes"
      ></astrobin-image-search-card>

      <astrobin-image-search-card
        #astrobinImageSearch
        *ngIf="
          !!equipmentItem && lineItem.totalImageCount > 0 && listing.listingType === MarketplaceListingType.FOR_SALE
        "
        [class.mt-5]="!lineItem.sellerImageCount"
        [header]="'Images from the AstroBin community' | translate"
        [loadMoreOnScroll]="false"
        [model]="{ itemId: lineItem.itemObjectId, itemType: lineItem.itemKlass, pageSize: 50 }"
        [showMarketplaceItems]="false"
        [showRetailers]="false"
        [showSortButton]="false"
        [showStaticOverlay]="false"
        [showUsageButton]="false"
        class="d-block"
        ordering="-likes"
      ></astrobin-image-search-card>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>

<ng-template #noDescriptionTemplate>
  <p class="text-muted mt-4">{{ "No description provided." | translate }}</p>
</ng-template>
